export default __webpack_public_path__ + "static/media/Medical_Fraud.cb4a2432.jpg";